import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button';
import Add from '../Icons/Add';
import { HouseListDirectory } from '../../constants/ComponentTypes';
import { isEnabledUserRole } from '../../utils/utils';

const styles = () => ({
  container: {
    margin: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },

  title: {
    fontSize: '18px',
    lineHeight: '22px',
  },

  subheading: {
    marginTop: '14px',
    lineHeight: '24px'
  },
});

const NoAddressPage = props => {
  const { classes, type, disabled } = props;

  let title, subheading;

  if (type === HouseListDirectory.MAIN.name) {
    title = 'アドレスは登録されていません';
    subheading = (<Typography variant="body2" className={classes.subheading}>
      アドレスを登録してレターを送付しましょう。
    </Typography>);
  } else if (type === HouseListDirectory.WARNING.name) {
    title = '警告ボックスは空です';
    subheading = (<Typography variant="body2" className={classes.subheading}>
      登録しようとしているターゲットが、すでに登録済みだった場合に、このボックスに登録<br />
      されます。ここに登録されたターゲットがレターの送付対象になることはありません。
    </Typography>);
  } else if (type === HouseListDirectory.ERROR.name) {
    title = 'エラーボックスは空です';
    subheading = (<Typography variant="body2" className={classes.subheading}>
      入力に不備のあるデータがこのボックスに登録されます。
    </Typography>);
  } else if (type === HouseListDirectory.NG_LIST.name) {
    title = '送付NGは登録されていません';
    subheading = (<Typography variant="body2" className={classes.subheading}>
      レターの送付対象から除外したいターゲット(既顧客、自社など)をこちらに登録します。<br />
      法人番号で自動突合するので、誤って登録してしまった場合にも安心です。<br />
      ＊ただし、法人番号ではなく、法人名や決裁者氏名でのご登録の場合、<br />
      揺らぎが発生し対象とみなされない可能性がございますのでご注意くださいませ。
    </Typography>);
  }


  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="display1" className={classes.title}> {title} </Typography>
        {subheading}
        {(() => {
          if (isEnabledUserRole(props.user, "house-list", "read") && (type === HouseListDirectory.MAIN.name || type === HouseListDirectory.NG_LIST.name)) {
            return (
              <Button
                text="新規登録"
                type="default"
                handleClickButton={disabled ? props.togglePlanDialog : props.toggleAddAddressDialog}
                size="medium"
                icon={<Add color="#FFFFFF" height={18} width={18} style={{ marginRight: '6px' }} />}
                style={{
                  marginTop: '52px',
                  paddingLeft: '14px',
                }}
              />
            )
          }
        })()}
      </div>
    </div>
  );
}

NoAddressPage.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  toggleAddAddressDialog: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  user: PropTypes.object,
};

export default withStyles(styles)(NoAddressPage);



// WEBPACK FOOTER //
// ./src/components/AddressBook/NoAddressPage.jsx